import { render, staticRenderFns } from "./Appearance.vue?vue&type=template&id=ddffaf4e&scoped=true"
import script from "./Appearance.vue?vue&type=script&lang=js"
export * from "./Appearance.vue?vue&type=script&lang=js"
import style0 from "./Appearance.vue?vue&type=style&index=0&id=ddffaf4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddffaf4e",
  null
  
)

export default component.exports